import React from 'react'
import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-bottom: var(--spacing-12);
  a {
    text-decoration: none;
  }
  a:hover {
    color: #0f5373;
  }
`

export const Header = styled.header`
  font-size: var(--fontSize-1);
  font-weight: bold;
  text-transform: uppercase;
`

export const Group = styled.ul`
  margin: 0;
  list-style-type: none;
`

export const Item = styled.li`
  margin: var(--spacing-3) 0;
  font-size: 85%;
`

export const List = ({ title, children }) => {
  return (
    <Wrapper>
      <Header>{title}</Header>
      <Group>{children}</Group>
    </Wrapper>
  )
}

List.Item = Item
